import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (active, n) => L.divIcon({
  className: "",
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  html: `<div style="width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-shadow:0 2px 6px rgba(60,40,10,.35);background:${active ? "#B8730A" : "#5B4A36"}"><span style="transform:rotate(45deg);color:#fff;font:600 11px Arial">${n}</span></div>`,
});

export default function RelayMap({ points, selected, onSelect }) {
  const el = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);

  useEffect(() => {
    map.current = L.map(el.current, { zoomControl: true, attributionControl: true, scrollWheelZoom: false });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: "© OpenStreetMap" }).addTo(map.current);
    layer.current = L.layerGroup().addTo(map.current);
    return () => map.current.remove();
  }, []);

  useEffect(() => {
    layer.current.clearLayers();
    const coords = [];
    points.forEach((p, i) => {
      const ll = [parseFloat(p.lat), parseFloat(p.lng)];
      if (Number.isNaN(ll[0]) || Number.isNaN(ll[1])) return;
      coords.push(ll);
      L.marker(ll, { icon: pin(selected?.id === p.id, i + 1), zIndexOffset: selected?.id === p.id ? 1000 : 0 })
        .on("click", () => onSelect(p)).addTo(layer.current);
    });
    if (coords.length && !selected) map.current.fitBounds(coords, { padding: [24, 24], maxZoom: 15 });
  }, [points, selected]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selected) map.current.panTo([parseFloat(selected.lat), parseFloat(selected.lng)]);
  }, [selected]);

  return <div ref={el} data-testid="relay-map" className="relative z-0 h-56 w-full overflow-hidden rounded-lg border border-amber-900/10" />;
}
